import React from "react";
import logo_pc from "../assets/logo/foot_gzh_zongyuan.jpg";

export default function Footer() {
  return (
    <footer>
      <div className="pageCon">
        <div className="footfl fl">
          <div className="foot_dz">
            <p>杭州四惠医院 | 服务热线：0571-88685312</p>
            <p>医院地址：杭州市余杭区五常街道联胜路10号华科西溪汇1幢</p>
          </div>
          <div className="foot_bq">
            <p>版权声明 | ©2022 hzshhospital.com 版权所有</p>
            <p>
              备案号：
              <a
                href="https://beian.miit.gov.cn"
                rel="nofollow"
                target="_blank"
              >
                浙ICP备17020822号-3
              </a>
            </p>
          </div>
          <div className="foot_info">
            提示：任何关于疾病的建议都不能替代执业医师的面对面诊断。所有门诊时间仅供参考，最终以医院当日公布为准。网友、医生言论权代表其个人观点，不代表本站同意其说法，请谨慎参阅，本站不承担由此引起的法律责任。
          </div>
        </div>
        <div className="footfr fr">
          <img src={logo_pc} />
          了解关注更多
        </div>
        <div className="clear"></div>
      </div>
    </footer>
  );
}
